import { CalculatorSkill, CalculatorSkillId, CalculatorSkillsGroup, CalculatorTabloRes } from 'src/types/calculator';
import { GradeId, GradeName } from 'src/types/grade';
import { ProfessionId } from 'src/types/profession';
import { ProfileSkillDto, ProfileSkillId } from 'src/types/profile';

export enum LoadingState {
    INITIAL = 'initial',
    LOADING = 'loading',
    LOADED = 'loaded',
    ERROR = 'error',
}

export type CalculatorContextTabloData = Omit<CalculatorTabloRes, 'professionId'>;

export interface CalculatorContextState {
    professionId: ProfessionId;
    gradeId: GradeId;
    gradeName: GradeName;
    skills: {
        all: CalculatorSkill[];
        map: Map<CalculatorSkillId, CalculatorSkill>;
    };
    skillsGroup: CalculatorSkillsGroup[];
    selectedSkills: {
        all: CalculatorSkill[];
        withCourse: CalculatorSkill[];
        withoutCourse: CalculatorSkill[];
        map: Map<CalculatorSkillId, CalculatorSkill>;
        isSelectSkills: boolean;
    };
    profileSkillsMap: Map<ProfileSkillId, ProfileSkillDto>;
    tablo: {
        data: CalculatorContextTabloData;
        isInitial: boolean;
        isLoading: boolean;
        isLoaded: boolean;
        isLoadError: boolean;
    };
    fillByProfile: {
        isFilled: boolean;
        handleFill: () => void;
        isHidden: boolean;
    };
    modalFillSkills: {
        isOpen: boolean;
        onClose: () => void;
    };
    modalLogin: {
        isOpen: boolean;
        onClose: () => void;
    };
    handleToggleSkill: (skill: CalculatorSkill) => void;
}
